import {
	EXCLUSIVE_DEALS_ARTWORK_DOUBLE_CLOUDINARY_OPTIONS,
	EXCLUSIVE_DEALS_ARTWORK_MULTIPLE_CLOUDINARY_OPTIONS,
	EXCLUSIVE_DEALS_ARTWORK_SINGLE_CLOUDINARY_OPTIONS,
	EXCLUSIVE_DEALS_ARTWORK_SINGLE_SMALL_CLOUDINARY_OPTIONS
} from '../../constants/home/general';
import { type CloudinaryOptions } from '../../helpers/cloudinary-helper/cloudinary-helper';

export const findExclusiveDealsArtworkImageCloudinaryOptions = (itemsCount: number, isNotSmall: boolean): CloudinaryOptions => {
	return itemsCount === 1 && isNotSmall
		? EXCLUSIVE_DEALS_ARTWORK_SINGLE_CLOUDINARY_OPTIONS
		: itemsCount === 1 && !isNotSmall
		? EXCLUSIVE_DEALS_ARTWORK_SINGLE_SMALL_CLOUDINARY_OPTIONS
		: itemsCount === 2
		? EXCLUSIVE_DEALS_ARTWORK_DOUBLE_CLOUDINARY_OPTIONS
		: EXCLUSIVE_DEALS_ARTWORK_MULTIPLE_CLOUDINARY_OPTIONS;
};
